
//add this product-modal to /index.js:  import "./js/product-modal.js";


import "js/vendors/slick.js";
import "js/vendors/jquery.magnific-popup.custom";




const S20 = window.S20 || {};
S20.settings = S20.settings || {};

S20.settings = {

	'siteId':'7c5bf23e-839a-4e8c-938c-a0401ac483f4',
	'zone':'zone0=CDP_Main_Product_Grid',//this one can be multiple,  zone0= &zone1=
	'region':ARCTERYX.WEBSITE_SETTINGS.COUNTRY,
	'currency':false,
	'fields':'name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised',
	'language':ARCTERYX.WEBSITE_SETTINGS.LANG.toLocaleLowerCase(),
	'config_warehouse':'ROCK',
	'config_region':ARCTERYX.WEBSITE_SETTINGS.COUNTRY,
	'config_categorytree':'WEBCAT',
	'config_gender':'MALE%2CFEMALE%2CNEUTRAL'
};


( function ( $ ) {

	
	S20.setupProductModal = function(){
		
		
		S20.settings.currency = S20.getCurrencyCode ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY, false )

		$("body").on( "click", ".slick-slide a", function(e) {
			
			if ($(this).hasClass("no-link")){
				//anything other than slick-current can be used to navigate if clicked on
				//two slideshows are only on mobile and only one on desktop with class '.slideshow'
				if ($("#mobile-sized").is(":visible") || $(this).parents(".slick-slider").hasClass("slideshow")){
					e.preventDefault();
				}
				//console.log("no link");
			}else{
				//console.log("follow link");
			}
		});

		
		$("body").on("click", ".rollover-tag, .rollover-tag--slideshow .slick-list, .rollover-tag .indicate-icon", function (e) {		
		//$(".rollover-tag, .rollover-tag--slideshow").click(function () {

			var $rolloverTag = $(this);
			if ($rolloverTag.hasClass('slick-list')) {
				$rolloverTag = $rolloverTag.parent().parent();
			}

			var sectionID = $rolloverTag.parents(".section-container").attr("id");

			S20.trackPropEvent("prop70", "eVar70", 'tagClick:' + sectionID + ':' + $rolloverTag.data( "panel" ) );
			
			//needs toString() or split doesn't work properly on single products
			var productArray = $rolloverTag.data("products").toString();
			var merchArray = $rolloverTag.data("merch-colour").toString();
			
			var isPopup = true;

  
			//console.log("productArray,merchArray",productArray.indexOf(','),merchArray.indexOf(','));
			//console.log(typeof merchArray);
			if (productArray){
				//if (productArray.indexOf(',') > -1){
				  productArray = productArray.split(',');
				//}else{
				//  productArray = [productArray];
				//}

				//if (merchArray.indexOf(',') > -1){
				  merchArray = merchArray.split(',');
				//}else{
				// merchArray = [merchArray];
				//}
				
				S20.openProductView(productArray,merchArray,isPopup);
			}
  
		} );

		var timerId;
		$("body").on( "mouseover", ".rollover-tag .indicate-icon", function() {

		  clearTimeout(timerId);

		  if ($("body").hasClass("desktop")){
			let $panel = $(this).parent().parent();
			

			  timerId = setTimeout(() => {

				  var sectionID = $(this).parents(".section-container").attr("id");

				  S20.trackPropEvent("prop70", "eVar70", 'tagHover:' + sectionID + ':' + $(this).data("panel"));
	
				  //needs toString() or split doesn't work properly on single products
				  var productArray = $panel.data("products").toString();
				  var merchArray = $panel.data("merch-colour").toString();

				  var isPopup = true;

				  if (productArray){
					  productArray = productArray.split(',');
					  if (merchArray){
						  merchArray = merchArray.split(',');
					  }
					  S20.openProductView(productArray,merchArray,isPopup);
				  }

				  $panel.toggleClass('active');

			}, 1400)
		  }
		});
		$("body").on( "mouseleave", ".rollover-tag .indicate-icon", function() {
		  let $panel = $(this).parent().parent();
		  $panel.removeClass('active');
		  clearTimeout(timerId);
		});

		//const url = 'https://esp-uat.locayta.com/zones-ajax.aspx?siteId=2cddd73a-34cf-4976-bb5c-fe99dc63747c&zone0=CDP_Main_Product_Grid&region=CA&currency=CA_CAD&fields=name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&language=en&config_warehouse=ROCK&config_region=CA&config_categorytree=WEBCAT&config_gender=MALE%2CFEMALE%2CNEUTRAL';


		//https://attraqt.arcteryx.com/zones-ajax.aspx?siteId=7c5bf23e-839a-4e8c-938c-a0401ac483f4&region=CA&currency=CA_CAD&fields=name%2Cprices%2Cimages%2Calt_image%2Crating%2Creview_count%2Cgender%2CFSM_CategoryTitles%2Curl%2Csubname%2Cshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&language=en&config_region=CAshortdescription%2CFSM_Color%2CFSM_Color_With_Regions%2CFSM_Attrimages%2Ccolor%2CbaseColor%2Cweight%2Csize%2Cnew%2Ctoprated%2Crevised&config_gender=MALE,NEUTRAL&zone0=LBClimb1_Mens&zone1=LBEveryday2_Mens&zone2=LBHike1_Mens



		const url = `https://attraqt.arcteryx.com/zones-ajax.aspx?siteId=${ S20.settings.siteId }&${ S20.settings.zone }&region=${ S20.settings.region }&currency=${ S20.settings.currency }&fields=${ S20.settings.fields }&language=${ S20.settings.language }&config_warehouse=${ S20.settings.config_warehouse }&config_region=${ S20.settings.config_region }&config_categorytree=${ S20.settings.config_categorytree }&config_gender=${ S20.settings.config_gender }`;


		$.ajax( {
		  url,
		  "crossDomain": true,
		  "success"( response ) {
			for ( let i = 0; i < response.zones.length; i++ ) {
			  const zone = response.zones[i];
  
			  if ( zone.status == "error" ) {
				console.error( `Error getting Attraqt zone for ${ zoneCart } error: ${ zone.error}` );
			  } else {
				
				let products = zone.data.results;
				let productsArray = [];
				
				  for ( let i = 0; i < products.length; i++ ) {
					/*
					 * If no prices, then data from Attraqt is invalid.
					 * Do not continue otherwise JS errors will stop cart from loading properly.
					 */
					if ( typeof products[i].fields.prices !== "undefined" ) {
					  
					  //console.log(products[i].fields.name.value[0]);
					  
					  productsArray.push(products[i].fields);
  
					}
				  }
				  S20.products = productsArray;
				  
				  
				  
			  }
			}
  
		  },
		  "error"() {
			console.error( "Error calling API" );
		  },
		} );


	};
	
	S20.getCurrencyCode = function ( countryCode, currencyOnly ) {
		switch ( countryCode.toUpperCase() ) {
		  case "US":
			if ( currencyOnly ) {
			  return "USD";
			}
			return "US_USD";
		  case "CA":
			if ( currencyOnly ) {
			  return "CAD";
			}
			return "CA_CAD";
		  case "DE":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "DE_EUR";
		  case "GB":
			if ( currencyOnly ) {
			  return "GBP";
			}
			return "GB_GBP";
		  case "PL":
			if ( currencyOnly ) {
			  return "PLN";
			}
			return "PL_PLN";
		  case "DK":
			if ( currencyOnly ) {
			  return "DKK";
			}
			return "DK_DKK";
		  case "NO":
			if ( currencyOnly ) {
			  return "NOK";
			}
			return "NO_NOK";
		  case "SE":
			if ( currencyOnly ) {
			  return "SEK";
			}
			return "SE_SEK";
		  case "AT":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "AT_EUR";
		  case "BE":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "BE_EUR";
		  case "CH":
			if ( currencyOnly ) {
			  return "CHF";
			}
			return "CH_CHF";
		  case "CZ":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "CZ_EUR";
		  case "ES":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "ES_EUR";
		  case "FI":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "FI_EUR";
		  case "FR":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "FR_EUR";
		  case "IE":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "IE_EUR";
		  case "IT":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "IT_EUR";
		  case "JP":
			if ( currencyOnly ) {
			  return "JPY";
			}
			return "JP_JPY";
		  case "CN":
			if ( currencyOnly ) {
			  return "CNY";
			}
			return "CN_CNY";
		  case "NL":
			if ( currencyOnly ) {
			  return "EUR";
			}
			return "NL_EUR";
		  default:
			if ( currencyOnly ) {
			  return "CAD";
			}
			return "CA-CAD";
		};
	};
		
	S20.trackPropEvent = function( prop, eVar, eventString ) {
		  const propObject = {};
		  const eVarObject = {};
	
		  propObject[prop] = eventString;
		  eVarObject[eVar] = eventString;

		  eVarObject['eVar3'] = window.location.href;
	
		  console.log('propObject', propObject);
		  console.log('eVarObject', eVarObject);
		   
	
		  ARCTERYX.analytics.trackEvent( {
			"category": "lookbook",
			"action": "",
			"label": eventString,
			"props": propObject,
			"eVars": eVarObject,
		  } );
	};



	//from shop-attraqt.js
	S20.getProductImage = function ( images, forCart ) {
		if ( images.length ) {
			let returnImage = images[images.length - 1];
			const imagesReverse = images.reverse();
			let i = 0;

			// Ensure it returns the last 350w image from the array
			for ( i = 0; i < imagesReverse.length; i++ ) {
			if ( imagesReverse[i].match( "350w" ) ) {
				returnImage = imagesReverse[i];
				break;
			}
			}

			if ( forCart ) {
			// Ensure it returns the last 162x205 image from the array
			for ( i = 0; i < imagesReverse.length; i++ ) {
				if ( imagesReverse[i].match( "162x205" ) ) {
				returnImage = imagesReverse[i];
				break;
				}
			}
			}

			return returnImage
			.replace( "-SAMPLE--", "" )
			.replace( "JAPAN-ONLY---CAYENNE", "Cayenne" )
			.replace( "JAPAN-ONLY---BLACK", "Black" ); // FE workaround for PDP17-1411
		}
		return null;
	};
	/*
	* Returns Array of alternate colour items
	*/
	//from shop-attraqt.js. slightly modified
	S20.setProductAltColours = function ( productName, altColourArr, imageUrl ) {
		const productAltColors = [];
		let colorItem;
		for ( let a = 0; a < altColourArr.length; a++ ) {
		// Only add colour if it is NOT restricted for the country
		if ( altColourArr[a].indexOf( `:${ ARCTERYX.WEBSITE_SETTINGS.COUNTRY };false` ) < 0 ) {
			const colourExclusion = new RegExp( ":[A-Z]{2};false", "g" );
			const colorName = altColourArr[a].split( ":" )[0];
			const baseColor = altColourArr[a].replace( colourExclusion, "" )
			.split( ":" )[1].toLowerCase()
			.replace( "/", "-" );
			const colorNameWithdashes = colorName.replace( /\/\s/g, "/" )
			.replace( /\//g, "-" )
			.replace( /\s/g, "-" );
			colorItem = {
				"colorProductName": productName,
				colorName,
				baseColor,
				"colorNameWithDashes": colorNameWithdashes,
				"altColorImage": `https://images.arcteryx.com/S20/50x75/${ productName }-${ colorNameWithdashes }.gif`,
				"mainImage": `https://images.arcteryx.com/S20/350w/${ productName }-${ colorNameWithdashes }.jpg`,
			};
			if ( imageUrl.match( colorNameWithdashes ) ) {
				productAltColors.unshift( colorItem );
			} else {
				productAltColors.push( colorItem );
			}
		}
		}
		return productAltColors;
	};






	S20.openProductView = function ( productArray, merchArray, isPopup, $that ) {
		let html = "";
		if ( merchArray ) {
			html = S20.returnProductView( productArray, merchArray, isPopup );
		}
	
		if ( isPopup ) {
			$.magnificPopup.open( {
			"items": {
				"src": html,
				"type": "inline",
			},
			"removalDelay": 600,
			"showCloseBtn": false,
			"callbacks": {
				"open"() {
				setTimeout( () => {
					$( ".product-container" )
					.addClass( "fade-in" );
				}, 200 );
				},
				"beforeClose"() {
				// SetTimeout(function(){
				$( ".product-container" )
					.removeClass( "fade-in" );
				// },1000)
				},
			},
			} );
		} else {
			$that.append( html );
		}
	
	
		$( ".swatch" )
			.click( function () {
			const index = $( this )
				.index();
			$( this )
				.parent()
				.find( ".swatch" )
				.removeClass( "selected" );
			$( this )
				.addClass( "selected" );
	
			$( this )
				.parent()
				.parent()
				.parent()
				.find( ".product-images .image" )
				.removeClass( "selected" );
			$( this )
				.parent()
				.parent()
				.parent()
				.find( ".product-images .image" )
				.eq( index )
				.addClass( "selected" );
			} );
	
	
		if ( isPopup ) {
			$( ".slideshow" )
			.on( "init", slick => {
				// Slideshow set to infinite so starting image is not .eq(0)
				$( slick.currentTarget )
				.find( ".slick-current" )
				.find( "a.image" )
				.removeClass( "no-link" );
				//console.log( ".slideshow init" );
			} );
	
			$( ".slideshow" )
			.slick( {
				"slidesToShow": 1,
				"slidesToScroll": 1,
				"infinite": true,
				"dots": false,
				"arrows": false,
				"centerMode": true,
				"centerPadding": "26%",
				"focusOnSelect": true,
				"speed": 200,
			} )
			.on( "afterChange", ( slick, slide ) => {
				slide.$slides.find( "a.image" )
				.addClass( "no-link" );
				slide.$slides.eq( slide.currentSlide )
				.find( "a.image" )
				.removeClass( "no-link" );
			} );
		} else {
			/*
			* TODO: this isn't going to be a slideshow at full width
			* going to have to make it disable and enable only when not in .mfp-content
			*/
	
	
			/*
			*[div.accordion-content]
			*[div.mobile-slideshow]
			*/
			$that.find( ".slideshow-grid" )
			.on( "init", slick => {
				/*
				* Console.log(slick.currentTarget);
				* console.log($(slick.currentTarget).find(".slick-slide").eq(0).find("a.image"));
				*/
				$( slick.currentTarget )
				.find( ".slick-slide" )
				.eq( 0 )
				.find( "a.image" )
				.removeClass( "no-link" );
			} );
	
	
			if ( $that.hasClass( "accordion-content" ) ) {
			$that.find( ".slideshow-grid" )
				.slick( {
				"slidesToShow": 1,
				"slidesToScroll": 1,
				"infinite": true,
				"dots": true,
				"arrows": false,
				"centerMode": true,
				"centerPadding": "26%",
				"focusOnSelect": true,
				"speed": 200,
				} )
				.on( "afterChange", ( slick, slide ) => {
				slide.$slides.find( "a.image" )
					.addClass( "no-link" );
				slide.$slides.eq( slide.currentSlide )
					.find( "a.image" )
					.removeClass( "no-link" );
				} );
			}
	
			if ( $that.hasClass( "mobile-slideshow" ) ) {
			$that.find( ".slideshow-grid" )
				.slick( {
				"slidesToShow": 1,
				"slidesToScroll": 1,
				"infinite": true,
				"dots": true,
				"arrows": false,
				"centerMode": true,
				"centerPadding": "26%",
				"focusOnSelect": true,
				"speed": 200,
				} )
				.on( "afterChange", ( slick, slide ) => {
				/*
					* Console.log("currentSlide:");
					* console.log(slide.currentSlide);
					* console.log(slide);
					* console.log(slide.$slides.find('a.image'));
					*/
				slide.$slides.find( "a.image" )
					.addClass( "no-link" );
				// Console.log(slide.$slides.eq(slide.currentSlide));
				slide.$slides.eq( slide.currentSlide )
					.find( "a.image" )
					.removeClass( "no-link" );
				} );
			}
		}
	
		/*
			* ARCTERYX.WEBSITE_SETTINGS.LANGUAGE
			* ARCTERYX.WEBSITE_SETTINGS.COUNTRY
			*/
	};
	

	S20.getLocalePrice = function ( hasDigitalData, price ) {
		let defaultLocale = null;
	
		if ( hasDigitalData ) {
		  defaultLocale = digitalData.websiteSettings.defaultCulture;
		}
	
		if ( $( "body" )
		  .hasClass( "CART" ) ) {
		  // Since Cart page currently not using Locale for currency format, match it for product recommendation pricing
		  defaultLocale = ARCTERYX.helpers.countryCodeToLocale( "CA" );
		} else if ( hasDigitalData && ( defaultLocale === null || defaultLocale == "" || digitalData.websiteSettings.country == "SE" ) ) {
		  defaultLocale = ARCTERYX.helpers.countryCodeToLocale( digitalData.websiteSettings.country );
		} else if ( ! hasDigitalData ) {
		  defaultLocale = ARCTERYX.helpers.countryCodeToLocale( ARCTERYX.WEBSITE_SETTINGS.COUNTRY );
		}
	
		if ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY === "JP" ) {
		  return price.toLocaleString( defaultLocale, { "minimumFractionDigits": 0, "maximumFractionDigits": 0 } );
		}
	
		return price.toLocaleString( defaultLocale, { "minimumFractionDigits": 2, "maximumFractionDigits": 2 } );
	};


	S20.returnProductView = function ( productArray, merchArray, isPopup ) {

		//let productListArray;
		let showCloseButton = true;
	

		
		
		//    productListArray = JSON.stringify( products );
		//    productListArray = JSON.parse( productListArray );
		
		//S20.products  contains all products
		
			
		//console.log(productsArray[0].id.value[0]);
		
		//console.log(productListArray);
		
		//var prodIds = ['11273','11272'];
		//var prodColors = ['2816','2681'];
		
		//console.log(productListArray[0].id.value[0]);
		var productListArray = [];
		S20.products.forEach(product => {
			if (productArray.includes(product.id.value[0])){

				//make array with IDs to select from
				productListArray[ product.id.value[0] ] = product;
			}  
			//console.log(product.id.value[0]);
			
		});
		console.log(productListArray);
		
		
		
			
			
	
	
	
		let slideshowClass = "slideshow";
	

		if ( productArray.length < 2 ) {
			slideshowClass = "slideshow-single";

			// ShowCloseButton = false;
		}
	
		if ( isPopup === false ) {
			slideshowClass = "slideshow-grid";
			showCloseButton = false;
		}
	
		let html = "<div class=\"product-container\">";
	
	
		html += "<div class=\"action-image empty\"></div>";
		slideshowClass += " no-action-image";
	
	
		html += `<div class="transition-container"><div class="${slideshowClass }">`;
	
		for ( let i = 0; i < productArray.length; i++ ) {
			const productId = productArray[i];
			const product = productListArray[productId];
	
			/*
			*MerchColour is not in this json file
			*var merchColour = product.merchColour;
			*/
	
			var selectedClass;
			let j = 0;
			let k = 0;

			let firstImage;
			let hasFirstImage = false;
			
	
			let productDetailsTxt = "Product Details";
	
			if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
			productDetailsTxt = "Voir les détails";
			} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
			productDetailsTxt = "Siehe Genauere Angaben";
			} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
			productDetailsTxt = "Vis Detaljer";
			} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
			productDetailsTxt = "Ver detalles";
			} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
			productDetailsTxt = "了解更多";
			} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
			productDetailsTxt = "詳細を見る";
			}


			try {
				hasFirstImage = true;
				//firstImage = product.colors[merchColour].ColorCd;
				firstImage = merchArray[i];
				//console.log('found merchColour');
			} catch (e) {
				//compiled.imageFileName = product.colors[firstColour].filename;
				hasFirstImage = false;
				console.log('Couldn\'t find data for merchColour:'+merchColour);
			}
	
			
			if ( product ) {
				html += "<div class=\"slide\"><div class=\"slide-container\">";
		
				html += "<div class=\"product-images\">";
		
		
				//const jsonProductColors = product.colors;
				let jsonProductColors = [];
				
		
		
				
		
				let gender = "";
				let genderForId = "";
				let productName = "";
	
				if ( product.gender.value[0].toLowerCase() === "male" ) {
					gender = "mens/";
				} else if ( product.gender.value[0].toLowerCase() === "female" ) {
					gender = "womens/";
					genderForId = "-W";
				}
	
				productName = product.url.value + genderForId;
	
			
				//product.fields.productAltColors = [];
				if ( product.FSM_Color_With_Regions ) {
					jsonProductColors = S20.setProductAltColours( productName, product.FSM_Color_With_Regions.value, S20.getProductImage( product.images.value, false ) );
				} else if ( product.FSM_Color ) {
					jsonProductColors = S20.setProductAltColours( productName, product.FSM_Color.value, S20.getProductImage( product.images.value, false ) );
				}
				
				
					//product.fields.imageUrl = S20.getProductImage( product.images.value, false );
			
					//console.log(S20.getProductImage( product.images.value, false ));
			
						
				/*
				const defaultColourRegex = new RegExp( `${product.url.value[0] }-(.+).jpg` );
				if ( product.imageUrl.match( defaultColourRegex ) === null ) {
					product.defaultColour = product.imageUrl.match( defaultColourRegex );
				} else {
					product.defaultColour = product.imageUrl.match( defaultColourRegex )[1];
				}
						
				console.log('product.defaultColour',product.defaultColour);
				*/
			
			
			   console.log(productName,'jsonProductColors',jsonProductColors);
				
				
				const model = ARCTERYX.helpers.modelConversionForNewPDP( product.url.value[0] );
				const productUrl = `/${ ARCTERYX.WEBSITE_SETTINGS.COUNTRY.toLowerCase() }/${ ARCTERYX.WEBSITE_SETTINGS.LANG.toLowerCase() }/shop/${ gender }${model}`;
				
				
				//let defaultImageNumber = 0;
				
			
					jsonProductColors.forEach(productColor => {
						//add first match
						var productImage = productColor.mainImage;
						if (productColor.colorName.includes(merchArray[i])){
							html += `<a href="${ productUrl }" class="image selected"><img src="${ productImage }"/></a>`;
						}
					});
					jsonProductColors.forEach(productColor => {
						//add everything else that doesn't match
						var productImage = productColor.mainImage;
						if (productColor.colorName.includes(merchArray[i]) === false){
							html += `<a href="${ productUrl }" class="image no-link"><img src="${ productImage }"/></a>`;
						}
					});
					
			
					html += "</div>";
			
					html += "<div class=\"product-content\">";
			
			
					
					html += "<div class=\"color-picker\">";
			
			
			

					

					jsonProductColors.forEach(productColor => {
						//add first selected thumb image
						var thumbImage = productColor.altColorImage;
						if (productColor.colorName.includes(merchArray[i])){
							html += `<div class="swatch selected" style="background-image:url(${ thumbImage })"></div>`;
						}

					});


					jsonProductColors.forEach(productColor => {
						//add the rest of the non-selected images
						var thumbImage = productColor.altColorImage;
						if (productColor.colorName.includes(merchArray[i]) === false){
							html += `<div class="swatch" style="background-image:url(${ thumbImage })"></div>`;
						}

					});
					
			
					html += "</div>";

			
					if ( product.new.value[0].toLowerCase() === "true" ) {
						if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
						html += "<div class=\"revised\">Neu</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
						html += "<div class=\"revised\">Nouveau</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
						html += "<div class=\"revised\">Ny</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
						html += "<div class=\"revised\">Nuevo</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
						html += "<div class=\"revised\">新商品</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
						html += "<div class=\"revised\">新款</div>";
						} else {
						html += "<div class=\"revised\">New</div>";
						}
					}
			
					if ( product.revised.value[0].toLowerCase() === "true" ) {
						if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
						html += "<div class=\"revised\">Überarbeitet</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
						html += "<div class=\"revised\">Revisité</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
						html += "<div class=\"revised\">Revidert utgave</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
						html += "<div class=\"revised\">Mejorado</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
						html += "<div class=\"revised\">改良</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
						html += "<div class=\"revised\">修改</div>";
						} else {
						html += "<div class=\"revised\">Revised</div>";
						}
					}
					/*
					if ( productListArray[productId].isNewColour == true ) {
						if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "GERMAN" ) {
						html += "<div class=\"revised\">Neue Farbe</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "FRENCH" ) {
						html += "<div class=\"revised\">Nouvelle couleur</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "NORWEGIAN" ) {
						html += "<div class=\"revised\">Ny farge</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "SPANISH" ) {
						html += "<div class=\"revised\">Nuevo color</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "JAPANESE" ) {
						html += "<div class=\"revised\">新色</div>";
						} else if ( ARCTERYX.WEBSITE_SETTINGS.LANGUAGE == "CHINESE" ) {
						html += "<div class=\"revised\">新色调</div>";
						} else {
						html += "<div class=\"revised\">New Colour</div>";
						}
					}
					*/
			
			
					html += `<div class="title">${ productListArray[productId].name.value[0] }</div>`;
					html += `<div class="description">${ productListArray[productId].shortdescription.value[0] }</div>`;
			



					let currencySymbolRight = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbolRight;
					let currency = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currency;
					let currencySymbol = ARCTERYX.helpers.priceDisplaySettings( ARCTERYX.WEBSITE_SETTINGS.COUNTRY ).currencySymbol;
					let price = S20.getLocalePrice( false, productListArray[productId].prices.value[0] );
					if ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY === "JP" ) {
					  price = price.replace( /\.[0-9]{2}\b/, "" );
					}


					if (currencySymbolRight){
						html += `<span class="price">${ price }${ currencySymbol }</span>`;

					}else{
						html += `<span class="price">${ currency }${ currencySymbol }${ price }</span>`;
					}

			
					html += S20.returnStarRating( productListArray[productId].rating.value[0], productListArray[productId].review_count.value[0] );
			
					html += `<div><a class="product-button SLB-product-button" href="${ productUrl }" title="${ productListArray[productId].name.value[0] }" data-english="${ productListArray[productId].name.value[0] }">${ productDetailsTxt }</a></div>`;
			
					html += "</div>";
			
			
					html += "</div></div>";
					} else {
					console.log( `No product for ID:${ productId}` );
					}
				}
			
			
				html += "</div>";
			
				if ( showCloseButton ) {
					html += "<button title=\"Close (Esc)\" type=\"button\" class=\"mfp-close\"><span class=\"ico-close\"></span></button>";
				}
			
				html += "</div>";// Transition container
				html += "</div>";
			
				return html;
		};
	
		S20.returnStarRating = function (rating, ratingCount) {

			let maxStars = 5,
				numStars = 0,
				count = 0,
				counts = rating.toString().split("."),
				wholeCount = parseInt(counts[0]),
				partial = parseFloat("0." + counts[1]),
				percent = partial * 100,
				markup = [];
			//
			for (var i = 0; i < wholeCount; i++) {
				numStars++;
				count++;
				markup += '<span class="star red">★</span>';
			}
			//
			if (percent > 0) {
				var partialStyle = 'width:' + percent + '%';
				numStars++;
				count++;
				markup += '<span class="star partial"><span class="background">★</span><span class="highlight" style=' + partialStyle + '>★</span></span>';
			}
			//
			if (numStars !== maxStars) {
				for (var i = 0; i < (maxStars - numStars); i++) {
				count++;
				markup += '<span class="star gray">★</span>';
				}
			}
		
			return '<span class="ratings"><span class="star-display"><span class="stars">' + markup + '</span></span><span class="count">(' + ratingCount + ')</span></span>';
		};




  $( document ).ready( () => {
	S20.setupProductModal();
  } );

}( jQuery ) );